import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { getCollectionPageData, getItemListData } from "@/lib/structuredData";
import { useExploreArtworks } from "@/hooks/useExploreArtworks";
import { ExploreFilters } from "@/components/explore/ExploreFilters";
import { ExploreActiveFilters } from "@/components/explore/ExploreActiveFilters";
import { ExploreResults } from "@/components/explore/ExploreResults";

export default function Explore() {
  const {
    category,
    setCategory,
    sortBy,
    setSortBy,
    artworkType,
    setArtworkType,
    showOnlyAuctions,
    selectedArtist,
    setSelectedArtist,
    advancedFilters,
    setAdvancedFilters,
    artists,
    availableCategories,
    filteredArtworks,
    totalCount,
    isLoading,
    isFetchingNextPage,
    observerTarget,
  } = useExploreArtworks();

  const pageTitle = showOnlyAuctions ? "Konstauktioner" : "Utforska konstverk";
  const pageDescription = showOnlyAuctions 
    ? "Buda på unika konstverk i pågående auktioner" 
    : "Upptäck och köp konst från svenska konstnärer - original, prints och auktioner";

  const structuredData = filteredArtworks && filteredArtworks.length > 0
    ? getItemListData(
        filteredArtworks.map((a: any) => ({
          id: a.id,
          title: a.title,
          description: a.description,
          price: a.price,
          image_url: a.artwork_images?.[0]?.image_url,
          artist_name: a.public_profiles?.full_name || a.public_profiles?.username
        })),
        pageTitle
      )
    : getCollectionPageData(pageTitle, pageDescription);

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title={showOnlyAuctions ? "Auktioner" : "Utforska konstverk"}
        description={showOnlyAuctions 
          ? "Buda på unika konstverk i pågående auktioner. Hitta originalverk och prints från svenska konstnärer." 
          : "Upptäck och köp konst från svenska konstnärer. Bläddra bland original, prints och pågående auktioner."}
        canonicalUrl="/explore"
        keywords={["köp konst", "konstverk", "original", "prints", "auktioner", "svenska konstnärer"]}
        structuredData={structuredData}
      />
      <Navbar />
      
      <div className="container py-2 sm:py-4 md:py-8 px-4 pb-24 sm:pb-32 md:pb-40">
        <div className="mb-3 sm:mb-4 md:mb-8">
          <h1 className="mb-1 text-xl sm:text-2xl md:text-4xl font-bold">
            {showOnlyAuctions ? "Auktioner" : "Utforska konstverk"}
          </h1>
          <p className="text-sm sm:text-base text-muted-foreground hidden sm:block">
            {showOnlyAuctions 
              ? "Buda på unika konstverk i pågående auktioner" 
              : "Hitta det perfekta konstverket från våra talangfulla konstnärer"
            }
          </p>
        </div>

        <ExploreFilters
          category={category}
          setCategory={setCategory}
          selectedArtist={selectedArtist}
          setSelectedArtist={setSelectedArtist}
          artworkType={artworkType}
          setArtworkType={setArtworkType}
          sortBy={sortBy}
          setSortBy={setSortBy}
          advancedFilters={advancedFilters}
          setAdvancedFilters={setAdvancedFilters}
          artists={artists}
          availableCategories={availableCategories}
        />

        <ExploreActiveFilters
          advancedFilters={advancedFilters}
          setAdvancedFilters={setAdvancedFilters}
        />

        <ExploreResults
          isLoading={isLoading}
          artworks={filteredArtworks}
          totalCount={totalCount}
          isFetchingNextPage={isFetchingNextPage}
          observerTarget={observerTarget}
        />
      </div>
      
      <Footer />
    </div>
  );
}
